/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { FlatList, InteractionManager, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Divider, IconButton, List, Text } from 'react-native-paper';
import { setPaperSize, setSelectedThermalPrinterDevice } from '../../store/thernam.printers.slice';
import * as storage from '../../services/storage';
import environment from '../../environment';
import { initThermalPrinter } from '../../services/Utils';
import { showToast } from '../../store/info.slice';
import Modal from 'react-native-modal';
import { modalConatiner, modalHeader, theme } from '../../theme/theme';

function ThermalPrinters({ navigation }) {
    const dispatch = useDispatch();
    const customer = useSelector((state) => state.customer?.customer);
    const devices = useSelector((state) => state.thermalPrinters?.devices);
    const selected_device = useSelector((state) => state.thermalPrinters?.selected_device);
    const paper_size = useSelector((state) => state.thermalPrinters?.paper_size);
    const [interactionCompleted, setIntersectionCompleted] = useState(false);
    const [isModalVisisble, setModalVisible] = useState(false);

    const closeModal = () => {
        setModalVisible(false);
    };

    const openModal = () => {
        setModalVisible(true);
    };


    useEffect(() => {
        const task = InteractionManager.runAfterInteractions(async () => {
            setIntersectionCompleted(true);
        });
        return () => {
            task.cancel();
        };
    }, []);

    useEffect(() => {
        if (interactionCompleted && customer) {
            initThermalPrinter(customer);
        }
    }, [interactionCompleted, customer]);

    const connectDevice = async (device) => {
        try {
            await window?.electronAPI?.setPrinter(device);
            dispatch(setSelectedThermalPrinterDevice(device));
            await storage.storeData('connected_thermal_printer', device);
        } catch (err) {
            console.error(err);
            dispatch(showToast(err?.msg || err?.message || JSON.stringify(err)));
        }
    };

    const disconnectDevice = async () => {
        try {
            await window?.electronAPI?.deletePrinter();
            dispatch(setSelectedThermalPrinterDevice(null));
            await storage.deleteData('connected_thermal_printer');
        } catch (err) {
            console.error(err);
            dispatch(showToast(err?.msg || err?.message || JSON.stringify(err)));
        }
    };

    const renderDevice = ({ item }) => {
        const isConnected = (selected_device === item);
        return (<List.Item
            title={item}
            right={props => <Button mode="text" onPress={() => isConnected ? disconnectDevice() : connectDevice(item)}>
                {isConnected ? 'Disconnect' : 'Connect'}
            </Button>}
        />);
    };


    const setPaperSizeHandler = async (size) => {
        try {
            closeModal();
            await new Promise((r) => setTimeout(r, 100));
            await window?.electronAPI?.setPaperSize(size);
            await storage.storeData('paper_size', size);
            dispatch(setPaperSize(size));
        } catch (error) {
            console.error(error);
        }
    };

    const ListFooterComponent = () => {
        return (
            <View>
                <Divider />
                <List.Item
                    title={'Paper Size'}
                    onPress={openModal}
                    right={props => (
                        <Button icon="chevron-down" onPress={openModal} style={{ flexDirection: 'row-reverse' }}>{paper_size || 'Select'}</Button>
                    )}
                />
                {devices.length > 0 && selected_device && (<View>
                    <Button mode="contained" onPress={() => window?.electronAPI?.testPrint()} style={{ margin: 6 }}>Test Print</Button>
                    {environment.ENV !== 'production' && <Button mode="contained" onPress={() => window?.electronAPI?.testPrintOrder()} style={{ margin: 6 }}>Test Order Print</Button>}
                </View>)}
            </View>
        );
    };

    const renderModal = () => {
        return (
            <Modal
                animationOutTiming={300}
                coverScreen={true}
                backdropTransitionOutTiming={300}
                hideModalContentWhileAnimating={true}
                isVisible={isModalVisisble}
                onBackButtonPress={closeModal}
                onBackdropPress={closeModal}
                style={modalConatiner}>
                <SafeAreaView style={styles.modalView}>
                    <View style={[modalHeader, { backgroundColor: theme.colors.primary }]}>
                        <Text variant="titleMedium" style={{ color: theme.colors.onPrimary }}>Select Paper Size</Text>
                        <IconButton
                            icon="close"
                            iconColor={theme.colors.onPrimary}
                            size={20}
                            onPress={closeModal}
                        />
                    </View>
                    <Divider />
                    <List.Item onPress={() => setPaperSizeHandler('80mm')} title="3-inch" />
                    <List.Item onPress={() => setPaperSizeHandler('58mm')} title="2-inch" />
                </SafeAreaView>
            </Modal>
        );
    };

    return (
        <SafeAreaView edges={['bottom']} style={styles.container}>
            {interactionCompleted &&
                <React.Fragment>
                    <View style={styles.mainContainer}>
                        <List.Item
                            title={'Devices'}
                            right={props => <Button icon="refresh" mode="text" onPress={() => window?.electronAPI?.getPrinters()}>
                                Refresh
                            </Button>}
                        />
                        <Divider />
                        <FlatList
                            data={devices}
                            renderItem={renderDevice}
                            keyExtractor={(item, index) => (index).toString()}
                            ItemSeparatorComponent={<Divider style={{ backgroundColor: '#dddddd' }} />}
                            ListFooterComponent={ListFooterComponent()}
                        />
                    </View>
                    {renderModal()}
                </React.Fragment>
            }
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f1f1f3',
    },
    mainContainer: {
        flex: 1,
        marginVertical: 8,
    },
    modalConatiner: {
        margin: 0,
        // flex: 1,
        justifyContent: 'flex-end',
    },
    modalView: {
        // flexGrow: 1,
        minHeight: '20%',
        backgroundColor: '#ffffff',
        paddingBottom: 16,
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
    },
    closeIcon: {
        position: 'absolute',
        top: 10, // Adjust as needed
        right: 10, // Adjust as needed
        backgroundColor: '#FFF',
        borderRadius: 20, // Makes it circular if height and width are equal
        width: 32,
        height: 32,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default ThermalPrinters;
